export class TemplateDetails {
    currentTemplateNo:number;
    totalTemplateNo:number;
    currentSelfTemplateNo:number;
    totalSelfTemplateNo:number;
  
    constructor() {
      this.currentTemplateNo = 0;
      this.totalTemplateNo = 0;
      this.currentSelfTemplateNo = 0;
      this.totalSelfTemplateNo = 0;
    }
  }